import { render, staticRenderFns } from "./TablaCandidatos.vue?vue&type=template&id=0081d83d&"
import script from "./TablaCandidatos.vue?vue&type=script&lang=js&"
export * from "./TablaCandidatos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports